<template>
  <div @click="onClick()" class="cert-home-content-card-parent">
    <div class="cert-home-content-card cert-dark cert-thin cert-search-result">
      <div class="d-flex flex-row">
        <div class="cert-title d-flex" @click="$router.push({name:'Alert',params: {id: id,type:type}})">
          <lorem-ipsum v-if="title==null" add="3w" class="mx-auto"></lorem-ipsum>
          <div v-if="title!=null">{{ title }}</div>
          <div class="cert-search-type" :class="getType()">{{ type }}</div>
        </div>
      </div>

      <div class="cert-text">
        <div style="display: inline-block" v-html="contentSub"></div>
        <span> ...</span>
      </div>
    </div>
  </div>
</template>

<script>
import LoremIpsum from 'vue-lorem-ipsum';

export default {
  name: "CertSearchResults",

  components: {
    LoremIpsum,
  },
  props: {
    id: String,
    title: String,
    date: String,
    content: String,
    image: String,
    type: String,
  },
  data() {
    return {
      contentSub: null,
    };
  },
  methods: {
    onClick() {
      this.$router.push({name: `Alert`, params: {id: this.id}})
    },
    getType() {
      if (this.type === "alert")
        return "cert-alert";
      if (this.type === "awareness")
        return "cert-awareness";
      if (this.type === "advisory")
        return "cert-advisory";
    },
  },
  created() {
    this.contentSub = this.content.substring(0, 100).trim();
  }
}
</script>